import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Simplified scroll utilities since scrollbars are now handled globally
export const scrollStyles = {
  default: ['tw-overflow-y-auto', 'tw-overflow-x-hidden', 'tw-overscroll-contain'],
  hidden: ['tw-overflow-y-auto', 'tw-overflow-x-hidden', 'tw-overscroll-contain', '[&::-webkit-scrollbar]:tw-hidden', 'scrollbar-width:none']
}

export const touchScrollProps = {
  touchAction: 'pan-y' as const
}